import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import qs from 'query-string';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';

import {
  selectIsApproveBuilderLoading,
  selectIsBuilderApproved,
} from '../../store/selectors';
import { confirmApproveBuilder } from '../../store/actions/builderApproval';
/* Styles */
import styles from './style';

const propTypes = {
  classes: PropTypes.object.isRequired,
  onConfirmApproveBuilder: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isApproved: PropTypes.number.isRequired,
  isDeactivate: PropTypes.bool,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

export const AuthoriseBuilderPage = props => {
  const {
    classes,
    onConfirmApproveBuilder,
    location,
    isLoading,
    isApproved,
    isDeactivate,
  } = props;

  const confirmBuilderToken = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  }).token;

  const handleClick = () => {
    onConfirmApproveBuilder(confirmBuilderToken, isDeactivate);
  };
  const getButtonContent = () => {
    if (isLoading) {
      return <CircularProgress size={20} />;
    }
    if (isDeactivate) {
      return 'Deactivate Builder';
    }
    return 'Authorise Builder';
  };

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        {isApproved === 1 && (
          <Typography variant="h5">
            Builder is now approved. You may close this window.
          </Typography>
        )}
        {isApproved === 2 && (
          <Typography variant="h5">
            Builder is now deactivated. You may close this window.
          </Typography>
        )}
        {isApproved === 0 && (
          <Button
            variant="contained"
            color="primary"
            onClick={handleClick}
            disabled={isLoading || isApproved !== 0}
          >
            {getButtonContent()}
          </Button>
        )}
      </div>
    </div>
  );
};

AuthoriseBuilderPage.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  isLoading: selectIsApproveBuilderLoading(),
  isApproved: selectIsBuilderApproved(),
});

const mapDispatchToProps = dispatch => ({
  // eslint-disable-next-line prettier/prettier
  onConfirmApproveBuilder: (confirmBuilderToken,isDeactivate) => dispatch(confirmApproveBuilder(confirmBuilderToken,isDeactivate))});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(AuthoriseBuilderPage),
);
